$('.product-single__gallery').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
        sync: '.product-single__thumbnails'
    }); 
  
  $('.product-single__gallery').on('change.flickity', function(event, index) {
      var $thumbnails = $('.product-single__thumbnails li');
      $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
      $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
  });
  $('.product-single__thumbnails li').first().addClass('active');
  
  // Thumbnail click event to change the gallery image
  
  $('.product-single__thumbnails li').on('click', function() {
      var index = $(this).index();
      $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
  });
    var swiper = new Swiper('.slider-upsell', {
    slidesPerView: 1,
    spaceBetween:8,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 50000,
      disableOnInteraction: false,
    },
     navigation: {
      nextEl: '.upsell_products .swiper-button-next',
      prevEl: '.upsell_products .swiper-button-prev',
    }
     
  });
  
    
  jQuery(document).ready(function($) {
   
    $('.nt_loadmore_mobmobi .rich-text__buttons a.button.button--primary').on('click', function() {
      $(this).hide();
      $(this).closest('.rich-text__blocks').toggleClass('active');
    });
    $('.nt_loadmore_mobmobi .rich-text__buttons a.button.button--secondary').on('click', function() {
      $(this).hide();
      $(this).closest('.rich-text__blocks').toggleClass('active');
    });
    $('body').on('click', '.banner__box p.icon_muted a', function(event) {
      event.preventDefault();
      $(this).toggleClass('muted');
      var video = $(this).closest('.banner_video').find('video'); 
      if( video.prop('muted') ){
        video.prop('muted', false);
        
      } else {
        video.prop('muted', true);
      }
    });
    slider_mobile();
    $(window).on('resize', function() {
        slider_mobile();
    });
  
    function slider_mobile() {
        if($(window).width() <= 949){
           $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
            e.preventDefault();
            $(this).toggleClass('active');
          });
             $(".trust__icons:not(.wirksam-st) .static-items").flickity({
                pageDots: false,
                freeScroll: false,
                wrapAround: true,
                prevNextButtons: false,
                cellAlign: 'left',
                 groupCells: true,
            });
            $(".nt_featured_collection ul").flickity({
               pageDots: false,
              prevNextButtons: true,
              cellAlign: 'left',
            });
            $(".slider-related ul.grid.product-grid:not(.flickity-enabled)").flickity({
                pageDots: false,
                prevNextButtons: true,
                cellAlign: 'left',
            });
            $(".nt_trust_icon_sec  .static-items.col-4").flickity({
                pageDots: false,
                prevNextButtons: false,
                cellAlign: 'left',
              });

            $(".section-collection-list .page-width .collection-list").flickity({
                 pageDots: false,
                freeScroll: false,
                wrapAround: true,
                prevNextButtons: false,
                cellAlign: 'center',
                groupCells: true,
                fade: true,
            });

        }
    }

   });